import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { App as CapacitorApp } from '@capacitor/app';

import fetcher from '../services/fetcher';
import log from '../services/log';
import GA from '../services/ga';
import auth from '../services/auth';

import 'cordova-plugin-purchase/www/store';

const Sub_1m = 'cw_test';
const Sub_1y = 'cw_1y_sub';

const Billing = {
	isOwned: () => {
		const { store } = window.CdvPurchase;
		return store.owned(Sub_1m) || store.owned(Sub_1y);
	},
	init: async () => {

		const { store, ProductType, Platform } = window.CdvPurchase;

		store.applicationUsername = () => Capacitor.getPlatform() === 'android' ? auth.getUser()._id : auth.getUser().userUUID;

		store.register([
		{
			type: ProductType.PAID_SUBSCRIPTION,
			id: Sub_1m,
			platform: Platform.GOOGLE_PLAY,
		},
		{
			type: ProductType.PAID_SUBSCRIPTION,
			id: Sub_1y,
			platform: Platform.GOOGLE_PLAY,
		},
		{
			type: ProductType.PAID_SUBSCRIPTION,
			id: Sub_1m,
			platform: Platform.APPLE_APPSTORE,
		},
		{
			type: ProductType.PAID_SUBSCRIPTION,
			id: Sub_1y,
			platform: Platform.APPLE_APPSTORE,
		}]);

		store.initialize([Platform.GOOGLE_PLAY, Platform.APPLE_APPSTORE]);
	},
	getSubInfo: (period) => {
		GA.track({
			category: 'Offer',
			action: `getSubInfo_${period}`
		})

		const { store, Platform } = window.CdvPurchase;

		const product = store.get(period === '1m' ? Sub_1m : Sub_1y, Capacitor.getPlatform() === 'android' ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE);
		log.traceTag('product', product);

		if (product && product.canPurchase){
			const pricing = product.pricing;
			log.traceTag('pricing', pricing);

			return {
				title: product.title,
				description: product.description,
				pricing: {
					price: pricing.price,
					currency: pricing.currency,
					period: pricing.billingPeriod
				},
				isOwned: product.owned
			};
		} else {
			GA.track({
				category: 'Offer',
				action: 'errorCanPurchase'
			})
			throw Error(`Can\'t get pricing from ${Capacitor.getPlatform()}`);
		}
	},
	manageSubscriptionsAndroid: () => {
		GA.track({
			category: 'Offer',
			action: 'manageSubscriptions'
		})
		log.traceTag('manageSubscriptionsAndroid');
		const { store, Platform } = window.CdvPurchase;

		const user = auth.getUser();
		store.applicationUsername = () => auth.getUser()._id;

		store.manageSubscriptions(Capacitor.getPlatform() === 'android' ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE);
	},
	// period - 1m, 1y
	buySub: (period) => {
		GA.track({
			category: 'Offer',
			action: `buySub_${period}`
		})
		const { store, Platform } = window.CdvPurchase;
		const user = auth.getUser();

		// rtdn is using user._id as reference id
		// assn shall use UUID (GUID) as reference id
		// Solution:
		// 1. Create a new field in users collection called userUUID
		// 2. Set userUUID as randomUUID() for all new users - done
		// 3. For old user, when they log in with ios check if userUUID is null and set value to randomUUID(), if not keep

		// for Android - set user._id
		// for iOS - set user.userUUID
		store.applicationUsername = () => Capacitor.getPlatform() === 'android' ? auth.getUser()._id : auth.getUser().userUUID;

		store.when()
			.approved(async (p) => {
				GA.track({
					category: 'Revenue',
					action: 'approved'
				})
				log.traceTag('approved', p);
				p.verify();
			}).verified(async (p) => {
				log.traceTag('verified', p);
				log.traceTag(p);
				GA.track({
					category: 'Revenue',
					action: 'verified'
				})
				const user = auth.getUser();

				// don't wait RTDN or ASSN to send subscription purchased event and unlock pro access locally
				// lookls like ios triggers this event everytime on sub renewal
				const response = Capacitor.getPlatform() === 'android' ? 
					await fetcher.unlockWithAndroid(
						user.email,
						period === '1m' ? 'pl_1' : 'pl_2'
					) : 
					await fetcher.unlockWithIOS(
						user.email,
						period === '1m' ? 'pl_1' : 'pl_2', // monthly sub code in DB
						auth.getUser().userUUID,
						"originalTransactionId"
					);

				log.traceTag('unlockWithMobile response', response);
		
				// if unlocked
				if (response.result){
					GA.track({
						category: 'Revenue',
						action: `proUnlocked_Mobile`
					})
					// refresh user token
					await auth.refreshUser();
					auth.proUnlocked();
					// auth.closeUnlockDialog(false);
					// finish transaction
					p.finish();
				}
			}).finished((p) => {
				log.traceTag('finished', p);
				GA.track({
					category: 'Revenue',
					action: 'finished'
				})
			})

			const offer = store.get(period === '1m' ? Sub_1m : Sub_1y, Capacitor.getPlatform() === 'android' ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE).getOffer();
			log.traceTag('offer', offer);
			log.traceTag('user to buy', user);
			const order = {
				applicationUsername: store.applicationUsername,
				googlePlay: {
					accountId: auth.getUser()._id // WARNING: don't change this
				}
			};

			log.traceTag('order', order);
			log.trace(order);
			offer.order(order);
	},
	manage: () => {
		GA.track({
			category: 'Offer',
			action: 'manageSubscriptions'
		})
		const { store, Platform } = window.CdvPurchase;

		store.manageSubscriptions(Capacitor.getPlatform() === 'android' ? Platform.GOOGLE_PLAY : Platform.APPLE_APPSTORE);
	}
}

export default Billing;